import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from './api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../models/Constants';
import * as _ from 'lodash';
import { columnsModel } from '../models/customer.model';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BatchAlertService {

  public currentColumns: columnsModel[] = [
    { field: 'externalRefId', header: 'Batch ID', width: 3 },
    { field: 'created', header: 'Created', width: 4 },
    { field: 'createdBy', header: 'Created By', width: 6 },
    { field: 'startDate', header: 'Start', width: 4 },
    { field: 'endDate', header: 'End', width: 4 },
    { field: 'alertCount', header: 'Applied To', width: 1 },
    { field: 'title', header: 'Title', width: 5 },
    { field: 'description', header: 'Description', width: 6 },
    { field: 'fileName', header: 'File Name', width: 12 }
  ];

  public deleteColumns: columnsModel[] = [
    { field: 'externalRefId', header: 'Batch ID', width: 3 },
    { field: 'deleted', header: 'Deleted', width: 4 },
    { field: 'deletedBy', header: 'Deleted By', width: 6 },
    { field: 'created', header: 'Created', width: 4 },
    { field: 'createdBy', header: 'Created By', width: 6 },
    { field: 'startDate', header: 'Start', width: 4 },
    { field: 'endDate', header: 'End', width: 4 },
    { field: 'alertCount', header: 'Applied To', width: 1 },
    { field: 'title', header: 'Title', width: 6 },
    { field: 'description', header: 'Description', width: 6 }
  ];


  leftNavBatchMenu = [
    { title: Constants.BATCH_ALERT_LEFT_NAV_MENU.CURRENT_BATCH_ALERT, icon: 'bell', isActive: true },
    { title: Constants.BATCH_ALERT_LEFT_NAV_MENU.ARCHIVED_BATCH_ALERT, icon: 'box-archive', isActive: false },
    { title: Constants.BATCH_ALERT_LEFT_NAV_MENU.DELETE_BATCH_ALERT, icon: 'trash', isActive: false },
    { title: Constants.BATCH_ALERT_LEFT_NAV_MENU.CREATE_BATCH_ALERT, icon: 'plus', isActive: false },
  ];


alertTypes : any[] = [];
clientId :any;
fileText:any ="";
files: any;
maxStartDate!: Date;
maxEndDate!: Date;
todayDate: Date = new Date();

adminForm = new FormGroup({
  clientId: new FormControl('', Validators.required),
})

createAlertForm = new FormGroup({
  alertType: new FormControl('', Validators.required),
  alertSubType: new FormControl('', Validators.required),
  title: new FormControl('', Validators.required),
  description: new FormControl('', Validators.required),
  detail: new FormControl('', Validators.required),
  start: new FormControl<Date | null>(new Date(), Validators.required),
  end: new FormControl<Date | null>(null, Validators.required),
  personFile : new FormControl<Date | null>(null, Validators.required)
});


  batchId: any;
  alertCount: any;
  subAlertTypes: any[]=[];
  currentbatchAlertErrMsg: boolean = false;
  currentBatchAlertData = new MatTableDataSource([]);
  currentBatchTableDataMap = new Map();
  archivedBatchAlertErrMsg: boolean = false;
  archivedBatchAlertData = new MatTableDataSource([]);
  archivedBatchTableDataMap = new Map();
  subTypeDetails: any;
  currentBatchSelectedRow: any;
  progressBarForDeleteBatchAlert: boolean = false;
  deleteBatchAlertMsgSuccess: boolean = false;
  deletedBatchAlertDetail: any;
  deleteBatchAlertMsgFail: boolean = false;
  openCurrentBatchFilterDialog: boolean = false;
  filteronCurrentBatchAlertApplied: boolean = false;
  filterCurrentBatchAlertFormData:any;
  viewParticipantData = new BehaviorSubject<any[]>([]);
  public viewParticipantDataSubject = new BehaviorSubject<any[]>([]); // Holds the data
  public viewParticipantData$ = this.viewParticipantDataSubject.asObservable(); 
  viewParticipantErrMsg: boolean = false;
  deletedBatchAlertErrMsg: boolean = false;
  deletedBatchAlertData = new MatTableDataSource([]);
  deletedBatchTableDataMap = new Map();
  batchAlertExpiryYear!: number;
  recordCountBatchAlert: number = 0;
  batchAlertExpiryDays!: number;


 constructor(public rootScope : RootScopeService,
              public apiService :ApiService
    ) { }

  getAlertTypes(clientId){
    if (this.rootScope.alertTypesDataMap[clientId])
      this.alertTypes = this.rootScope.alertTypesDataMap[clientId]?.data?.alertConfiguration;
  else
      this.getAlertTypesFromServer(clientId);
  }


 getAlertTypesFromServer(clientId){
  this.apiService.getAlertTypes(clientId).subscribe({
    next: (data: any) => {
      this.alertTypes = data.data.alertConfiguration;
      this.rootScope.alertTypesDataMap[clientId] = data;
    },
    error: (error) => {
      this.alertTypes  = [];
      this.rootScope.alertTypesDataMap[clientId] = [];
    },

   })
 }

 getDataForCurrentBatchAlert(clientId){
   if(this.currentBatchTableDataMap.get(clientId)){
      this.currentbatchAlertErrMsg = false;
      if(this.filteronCurrentBatchAlertApplied) return;
      this.currentBatchAlertData = new MatTableDataSource(this.currentBatchTableDataMap.get(clientId));
   }
   else{
     this.getDataForCurrentBatchAlertFromServer(clientId);
   }

 }

     
 getDataForCurrentBatchAlertFromServer(clientId){
  this.apiService.getCurrentBatchAlertsData(clientId).subscribe({
    next: (data1: any) => {
      console.log("data",data1);
      let data = data1?.data || [];     
      this.currentBatchAlertData = new MatTableDataSource(data);
      this.currentbatchAlertErrMsg = false;
      let that = this;
      data.map(function(each){
        each['createdBy'] = each?.creator?.name;
        each['startDate'] = that.rootScope.getDate(each?.begin);
        each['endDate'] = that.rootScope.getDate(each?.end);
        each['created'] = that.rootScope.getDate(each?.created);
      })
      this.currentBatchTableDataMap.set(clientId, data)
    },
    error: (error) => {
      this.currentbatchAlertErrMsg = true;
     },
  })                
}
getDataforArchivedAlert(clientId){
  if(this.archivedBatchTableDataMap?.get(clientId)){
     this.archivedBatchAlertErrMsg = false;
     this.archivedBatchAlertData = new MatTableDataSource(this.archivedBatchTableDataMap.get(clientId));
  }
  else{
    this.getDataforArchivedAlertFromServer(clientId);
  }

}

  
  getDataforArchivedAlertFromServer(clientId) {
    this.apiService.getArchivedBatchAlertsData(clientId).subscribe({
      next: (data1: any) => {
        console.log("data-archived", data1);
        let data = data1?.data || [];
        this.archivedBatchAlertData = new MatTableDataSource(data);
        this.archivedBatchAlertErrMsg = false;
        let that = this;
        data?.map(function (each?) {
          each['createdBy'] = each?.creator?.name;
          each['startDate'] = that.rootScope.getDate(each?.begin);
          each['endDate'] = that.rootScope.getDate(each?.end);
          each['created'] = that.rootScope.getDate(each?.created);
        })
        this.archivedBatchTableDataMap.set(clientId, data)
      },
      error: (error) => {
        this.archivedBatchAlertErrMsg = true;
      },
    })
  }

  getDataForViewParticipantFromServer(BatchId: string, recordCount: number, skipCount: number) {
    return this.apiService.getViewParticipantBatchAlert(BatchId, recordCount, skipCount).pipe(
      map((response: any) => {
        this.viewParticipantErrMsg = false;
        return response?.data?.map((udpId: string) => ({ globalUDPId: udpId }));
      }),
      catchError((error) => {
        console.error('Error fetching view participant data from server:', error);
        this.viewParticipantErrMsg = true;
        return of([]);
      })
    );
  }

  fetchandUpdateViewParticipantData(BatchId: string, recordCount: number, skipCount: number): void {
    this.getDataForViewParticipantFromServer(BatchId, recordCount, skipCount).subscribe({
      next: (transformedData: any[]) => {
        this.viewParticipantDataSubject.next(transformedData);
      },
      error: (error) => {
        console.error('Error fetching  View Participant data:', error);
        this.viewParticipantErrMsg = true;
      }
    });
  } 

 turnBatchAlertModeOn() {
  this.rootScope.activeLink = Constants.Administration;
  let item = { name: 'Administration', selected: false, id: 'administration'}

  let simTab = this.rootScope.items?.filter(item => item?.id == 'administration');
  if (simTab?.length == 0)
    this.rootScope.items?.push(item);

  this.rootScope.router.navigate(['/administration'], {
    skipLocationChange: true,
  });
  let adminSelTab: any = _.find(
    this.rootScope.items,
    (each) => each?.id == Constants.Administration
  );
  adminSelTab['selected'] = true;
  setTimeout(() => {
    this.rootScope.batchAlertData.isBatchAlertModeActive = true;
    sessionStorage.setItem('isBatchAlertModeActive', 'true');
    this.rootScope.batchAlertData.isBatchAlertToggleOn = true;
    this.rootScope.openViewParticipant = false;
  }, 250);

}

turnBatchAlertModeOff() {
  this.rootScope.activeLink = Constants.CCR_Dashboard;
  this.rootScope.router.navigate(['/dashboard'], {
    skipLocationChange: true,
  });
  let dashSelTab: any = _.find(
    this.rootScope.items,
    (each) => each?.id == Constants.CCR_Dashboard
  );
  dashSelTab['selected'] = true;

  setTimeout(() => {
    this.rootScope.batchAlertData.isBatchAlertModeActive= false;
    sessionStorage.setItem('isBatchAlertModeActive', 'false');
   this.rootScope.batchAlertData.isBatchAlertToggleOn= false;
   this.currentBatchSelectedRow = null;
   this.deleteBatchAlertMsgSuccess = false;
   this.deleteBatchAlertMsgFail = false;
   this.deletedBatchAlertDetail = null;
   this.filterCurrentBatchAlertFormData = null;
   this.filteronCurrentBatchAlertApplied = false;
   this.rootScope.openViewParticipant = false;
   this.viewParticipantErrMsg = false;
   this.rootScope.items = this.rootScope.items?.filter(items => items?.id != 'administration');
   this.setActiveMenu('Current Batch Alert');
  }, 250);


}

turnBatchAlertModeOnWithoutRoute() {
  let item = { name: 'Administration', selected: false, id: 'administration'}

  let simTab = this.rootScope.items?.filter(item => item?.id == 'administration');
  if (simTab?.length == 0)
    this.rootScope.items?.push(item);
 
  setTimeout(() => {
    this.rootScope.batchAlertData.isBatchAlertModeActive = true;
    sessionStorage.setItem('isBatchAlertModeActive', 'true');
    this.rootScope.batchAlertData.isBatchAlertToggleOn = true;
    this.rootScope.openViewParticipant = false;
  }, 250);

}

setActiveMenu(title: string) {
  this.leftNavBatchMenu = this.leftNavBatchMenu?.map(menuItem => ({
    ...menuItem,
    isActive: menuItem?.title === title
  }));
}

 /**
   * Check the session storage has isBatchAlertModeActive value 'true' and return boolean
   */
 checkBatchAlertModeActive(): boolean {
  const storedValue = sessionStorage?.getItem?.('isBatchAlertModeActive');
  return storedValue === 'true';
}

/**
* Below method is used to delete the batch alert from Current Batch Alert of Administration TAB
* @param batchAlertId 
*/
deleteBatchAlert() {
  this.progressBarForDeleteBatchAlert = true;
  this.deleteBatchAlertMsgSuccess = false;
  this.deleteBatchAlertMsgFail = false;
  this.deletedBatchAlertDetail = null;
  const batchAlertId = this.currentBatchSelectedRow?.externalRefId;
    /* istanbul ignore next */
  if (batchAlertId) {
    this.apiService.deleteBatchAlert(batchAlertId).subscribe({
      next: (data: any) => {
        this.deletedBatchAlertDetail = data?.data;
        this.deleteBatchAlertMsgSuccess = true;
        this.progressBarForDeleteBatchAlert = false;
        this.rootScope.dialog.closeAll();
        this.currentBatchSelectedRow = null;
        this.filteronCurrentBatchAlertApplied = false;
        this.filterCurrentBatchAlertFormData = null;
        this.getDataForCurrentBatchAlertFromServer(this.clientId);
        this.getDataforDeletedBatchAlertFromServer(this.clientId);
        console.log(data);
      },
      error: (err: any) => {
        this.deleteBatchAlertMsgFail = true;
        this.progressBarForDeleteBatchAlert = false;
        this.rootScope.dialog.closeAll();
        console.log(err);
      }
    })
  }

}

/**
 * Below method check the deleted batch alert data in deletedBatchTableDataMap and if found it returns the data
 *  otherwise in else condition it hit the backend API to fetch the data
 * CCR1-5852
 * @param clientId 
 */
getDataforDeletedBatchAlert(clientId){
  if(this.deletedBatchTableDataMap?.get(clientId)){
     this.deletedBatchAlertErrMsg = false;
     this.deletedBatchAlertData = new MatTableDataSource(this.deletedBatchTableDataMap?.get(clientId));
  }
  else{
    this.getDataforDeletedBatchAlertFromServer(clientId);
  }

}

/**
 * Below method hit the backend API to fetch the deleted data
 * CCR1-5852
 * @param clientId 
 */
  getDataforDeletedBatchAlertFromServer(clientId){
 this.apiService.getDeletedBatchAlertsData(clientId).subscribe({
   next: (data1: any) => {
     console.log("data-deleted",data1);
     let data = data1?.data || [];
     this.deletedBatchAlertData = new MatTableDataSource(data);
     this.deletedBatchAlertErrMsg = false;
     let that = this;
     data.map(function(each){
       each['deleted'] = that.rootScope.getDate(each?.deleted);
       each['deletedBy'] = each?.deletor?.name;
       each['created'] = that.rootScope.getDate(each?.created);
       each['createdBy'] = each?.creator?.name;
       each['startDate'] = that.rootScope.getDate(each?.begin);
       each['endDate'] = that.rootScope.getDate(each?.end);
     })
     this.deletedBatchTableDataMap.set(clientId, data)
   },
   error: (error) => {
     this.deletedBatchAlertErrMsg = true;
    },
 })                
}

  

}